import { useMemo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";

export default function CompanySelect() {
  const nav = useNavigate();
  const firm_token = localStorage.getItem("firm_token");

  const companies = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("companies_json") || "[]");
    } catch { return []; }
  }, []);

  if (!firm_token) return <Navigate to="/firm/login" replace />;

  const pick = (c) => {
    localStorage.setItem("company_id", c._id_str);
    localStorage.setItem("company_name", c.name);
    nav("/firm/portal");
  };

  // 0 companies — legacy firm without setup; proceed with backend default
  if (companies.length === 0) {
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_name");
    return <Navigate to="/firm/portal" replace />;
  }

  // 1 company — auto-select
  if (companies.length === 1) {
    localStorage.setItem("company_id", companies[0]._id_str);
    localStorage.setItem("company_name", companies[0].name);
    return <Navigate to="/firm/portal" replace />;
  }

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-6">
      <div className="w-full max-w-3xl bg-white border border-border rounded-lg p-8" data-testid="company-select-page">
        <div className="overline mb-2">Choose Company</div>
        <h1 className="text-3xl font-bold tracking-tight">
          {localStorage.getItem("firm_token_name")}
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          This firm has {companies.length} companies. Pick one to continue.
        </p>
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          {companies.map((c) => (
            <button
              key={c._id_str}
              onClick={() => pick(c)}
              data-testid={`company-pick-${c._id_str}`}
              className="border border-border rounded-lg p-6 text-left hover:border-[#064E3B] hover:bg-slate-50 transition-colors"
            >
              <Building2 className="text-[#064E3B] mb-2" />
              <div className="text-lg font-bold">{c.name}</div>
              {c.gstin && <div className="text-xs text-muted-foreground mt-1 font-mono">{c.gstin}</div>}
              {c.state && <div className="text-xs text-muted-foreground">{c.state}</div>}
              {c.active === false && <span className="chip chip-slate mt-2">Inactive</span>}
            </button>
          ))}
        </div>
        <div className="mt-6 text-xs text-muted-foreground">
          Owners can add/remove companies from Settings → Companies. Accountants are
          bound to a specific company by the owner.
        </div>
      </div>
    </div>
  );
}
